<template>
    <a :class="`logo ${small ? 'small' : ''}`" href="/espace-client">
        <img v-if="small" :src="logoSmallUrl" :alt="$publicDico.header.logo.baseline" />
        <img v-else :src="logoUrl" :alt="$publicDico.header.logo.baseline" />
    </a>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    props: ["small"],
    computed: {
        logoUrl() {
            return `${this.$publicDico.general.assets_url}/svg/diode.svg`;
        },
        logoSmallUrl() {
            return `${this.$publicDico.general.assets_url}/svg/diode-small.svg`;
        },
    },
});
</script>

<style lang="sass" scoped>
.logo
    img
        height: 80px
.logo.small
    img
        height: 25px
</style>
